import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import arTranslations from './ar'
import esEsTranslations from './es-ES'
import itItTranslations from './it-IT'
import deDeTranslations from './de-DE'
import frFrTranslations from './fr-FR'

// https://support.mozilla.org/pt-BR/kb/abreviacao-de-localizacao
export default {
  ar: arTranslations,
  'es-ES': esEsTranslations,
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
  'it-IT': itItTranslations,
  'de-DE': deDeTranslations,
  'fr-FR': frFrTranslations,
}
